import { Component, computed, input, model } from '@angular/core';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { ChitinFormInputComponent } from '@shared/components/chitin/atoms/form-input/form-input.component';
import { DateRange as MsgDateRange } from '@shared/components/chitin/molecules/daterange-picker/date-range';
import { DaterangePickerComponent } from '@shared/components/daterange-picker/daterange-picker.component';
import dayjs, { Dayjs } from 'dayjs';

@Component({
  selector: 'app-input-daterange-picker',
  templateUrl: 'input-daterange-picker.component.html',
  styleUrl: './input-daterange-picker.component.scss',
  imports: [ChitinFormInputComponent, DaterangePickerComponent, NgbPopoverModule],
})
export class InputDaterangePickerComponent {
  showTimezoneSelector = input(false);
  dateFormat = input<string>('MMM D, YYYY');
  isDisabled = input(false);
  minDate = input<Date | Dayjs | string>();
  maxDate = input<Date | Dayjs | string>();
  size = input<'small' | 'medium' | 'large'>('medium');
  placeholder = input<string>('Select date');
  appendTo = input<'body'>();

  protected dateRange = model<MsgDateRange>();

  checkClearValue(value: unknown) {
    if (value === null) {
      this.dateRange.set(undefined);
    }
  }

  protected dateRangeFormatted = computed(() => {
    const dateRange = this.dateRange();
    if (!dateRange) return null;
    const from = dayjs(dateRange.from);
    const to = dayjs(dateRange.to);
    if (from.date() === to.date()) {
      return `${from.format(this.dateFormat())}`;
    }
    return `${from.format(this.dateFormat())} - ${to.format(this.dateFormat())}`;
  });
}
